import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CallbackComponent} from './callback.component';
import {CallbackRoutingModule} from "./callback-routing.module";
import { CbNaverComponent } from './cb-naver/cb-naver.component';
import { CbNaverIosComponent } from './cb-naver-ios/cb-naver-ios.component';
import { CbNaverAndroidComponent } from './cb-naver-android/cb-naver-android.component';


@NgModule({
  declarations: [
    CallbackComponent,
    CbNaverComponent,
    CbNaverIosComponent,
    CbNaverAndroidComponent,
  ],
  imports: [
    CommonModule,
    CallbackRoutingModule
  ],
})
export class CallbackModule {
}
